import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import { NamedLink } from '../../../components';

import css from './SectionHeroMobile.module.css';

import reversedLogo from '../images/reversedLogo.png';
import couchPic from '../images/Home-2.png';

const SectionHeroMobile = props => {
  const {
    rootClassName,
    className,
    gateImage,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.top}>
        <p className={css.tightText}>A marketplace</p>
        <p className={css.tightText}>for timeless</p>
        <p className={css.tightText}>interiors &</p>
        <p className={css.tightText}>furniture</p>
      </div>
      <div className={css.center}>
        <div className={css.heroImageWrapper}>
          <img
            src={reversedLogo}
            className={css.reversedLogoAnimated}
          />
          <img
            src={couchPic}
            className={gateImage === 'couchTexture' ? css.gatePic : css.gatePicHidden}
          />
        </div>
      </div>
      <div className={css.buttons}>
        <NamedLink name="SearchPage" className={css.heroLeftButton}>
          SHOP
        </NamedLink>
        <NamedLink name="NewListingPage" className={css.heroLeftButton}>
          SELL
        </NamedLink>
      </div>
    </div>
  );
};

SectionHeroMobile.defaultProps = { rootClassName: null, className: null };

SectionHeroMobile.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHeroMobile;
